import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        similarityObject: Array(),
        entityObject: Array(),
    },
    mutations: {
        updateSimilarityObject(state, similarity) {
            state.similarityObject = similarity
            // console.log(state.similarityObject.records[0]._fields[0].properties.chunk_id)
        },
        updateEntityObject(state, entity) {
            state.entityObject = entity
            console.log(state.entityObject)
        }
    },
    getter: {
    },
    actions: {
    },
    models: {
    }
});